export default __webpack_public_path__ + "static/media/hands.34bdb9fa.svg";